import { render } from "./index.vue?vue&type=template&id=7c59895e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=7c59895e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7c59895e"

export default script